<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2023. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn
            :id="`iiotComposeWebUiLink_${index}`"
            :href="serviceWebUI"
            target="_blank"
            :disabled="!isOpenUiEnabled"
            class="openUiLink"
            text
          >
            {{ tableItem.serviceName }}
          </v-btn>
        </div>
      </template>
      <span>{{ isOpenUiEnabled ? $t('defaultTable.webUi') : $t('defaultTable.webUiDisabled') }}</span>
    </v-tooltip>
  </div>
</template>
  
<script>
const STATUSES = {
  IDLE: 0,
  CREATING: 1,
  REMOVING: 2,
  SUSPENDING: 3,
  SUSPENDED: 4,
  STARTING: 5,
  RESTARTING: 6,
  RESUMING: 7,
  STARTED: 8,
  STOPPING: 9,
  STOPPED: 10,
  ERROR: 11,
  REMOVING_FAILED: 12,
  PARTIALLY_RUNNING: 13,
};

export default {
  props: {
    tableItem: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    serviceWebUI() {
      return `${this.tableItem.locationUrl}`;
    },
    isOpenUiEnabled() {
      if (this.workloadStatus === STATUSES.REMOVING || this.workloadStatus === STATUSES.REMOVING_FAILED) {
        return false;
      }
      const selectedService = this.servicesWithStatuses?.find(
        (service) => service.containerName === this.tableItem.containerName,
      );
      return selectedService ? selectedService.state === STATUSES.STARTED : false;
    },
    servicesWithStatuses() {
      return this.$store.getters['workload/getSelectedComposeWl'].servicesWithStatuses || [];
    },
    workloadStatus() {
      return STATUSES[this.$store.getters['workload/getSelectedComposeWl'].currentStatus.toUpperCase()];
    },
  },
};
</script>

<style lang="scss">
.openUiLink {
  width: 100% !important;
  justify-content: start !important;
  text-transform: none !important;
  color: #000000de !important;
}
.openUiLink:hover {
  color: var(--v-primary-base) !important;
}
</style>
  